import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmdbRegisterPageAttachmentComponent } from './cmdb-register-page-attachment.component';

@NgModule({
	declarations: [],
	imports: [CmdbRegisterPageAttachmentComponent],
	exports: [CmdbRegisterPageAttachmentComponent],
})
export class CmdbRegisterPageAttachmentModule {}
